import React from 'react'
import Button from '@mui/material/Button'
import { setNotification } from '../../components/ui-widgets/uiWidgetsSlice'
import { useAppDispatch } from '../../../app/hooks'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import AddModeratorIcon from '@mui/icons-material/AddModerator'
import {
  useLegacyApiAddInstitutionKycResultMutation
} from '../../../api-services/asset-holdings/assetHolderApi'

interface AddInstitutionalKYCComponentProps {
  assetHolder: AssetHolderUpdateDto
}

const AddInstitutionalKYCComponent = (props: AddInstitutionalKYCComponentProps): JSX.Element => {
  const dispatch = useAppDispatch()
  const { assetHolder } = props

  const [apiAddKycResultTrigger] = useLegacyApiAddInstitutionKycResultMutation()

  const handleResetKYC = (): void => {
    apiAddKycResultTrigger({
      assetHolderId: assetHolder.assetHolderId,
      status: 'PASSED'
    })
      .unwrap()
      .then(() => {
        dispatch(setNotification({ open: true, severity: 'success', message: 'Institutional KYC added successfully.' }))
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }

  const openConfirmDialog = (): void => {
    const choice = window.confirm(
      'Are you sure you want to add Institutional KYC?'
    )
    if (choice) {
      handleResetKYC()
    }
  }

  return (
    <React.Fragment>
      <Button
        variant={'outlined'}
        startIcon={<AddModeratorIcon />}
        onClick={openConfirmDialog}
        disabled={assetHolder.latestLegacyKycResult?.status === null || assetHolder.latestLegacyKycResult?.status === undefined || assetHolder.latestLegacyKycResult?.status !== 'INCOMPLETE'}
      >
        Add Institutional KYC
      </Button>
    </React.Fragment>
  )
}

export default AddInstitutionalKYCComponent
